export const MAC_MDM = 'jamf';
export const WINDOWS_MDM = 'kaseya';
